module.exports = __webpack_public_path__ + "img/DSC07448.028513ec.jpg";